import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {RouterModule} from '@angular/router';
/* MODULES DE LAYOUT */
import {SidebarModule} from './sidebar/sidebar.module';
import {ContentModule} from './content/content.module';
import {Ng2DeviceDetectorModule} from 'ng2-device-detector';
/* COMPONENTES DE LAYOUT */
import {LayoutComponent} from './layout.component';
import {LayoutService} from "./recursos/servicio/layout.service";
import {SpeechRecognitionService} from "./recursos/servicio/speech-recognition.service";
import {MomentModule} from "angular2-moment";
import {NavbarModule} from "./shared/navbar/navbar.module";
import {FooterModule} from "./shared/footer/footer.module";
import {LoadingModule} from "../autenticacion/loadingScreen/loading.module";


@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule,
        SidebarModule,
        FooterModule,
        NavbarModule,
        ContentModule,
        Ng2DeviceDetectorModule.forRoot(),
        MomentModule,
        LoadingModule
    ],
    declarations: [LayoutComponent],
    providers: [LayoutService, SpeechRecognitionService]


})
export class LayoutModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/layout.module.ts